import { render, staticRenderFns } from "./CommissionPreview.vue?vue&type=template&id=20a8139c"
import script from "./CommissionPreview.vue?vue&type=script&lang=js"
export * from "./CommissionPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports